<template>
  <div>
    <div class="bjb1f"></div>
    <div class="headBj img">
      <div class="headImg">
        <img src="../../assets/img/monyBj.jpg" />
      </div>
      <div class="headBjBox">
        <div class="moyHeadBox">
          <div class="logo img" @click="syJump">
            <img src="../../assets/img/logo.png" alt="" />
          </div>
          <div class="box dis-cent" v-if="xsShow" @click="logJump">登录</div>
        </div>
        <div class="moyTitle">
          <div class="name">加入玉环人力网会员</div>
          <div class="name">帮您更快招到合适的求职者</div>
          <div class="text">提供了多种权益尽享便捷</div>
        </div>
        <div class="moyCont">
          <div class="box">
            <div class="name">普通用户</div>
            <div class="contBox">
              <div class="textBox">
                <div class="yuan dis-cent">
                  <div class="iconfont icon-close"></div>
                </div>
                <div class="txt">免费发布招聘信息</div>
              </div>
              <div class="textBox">
                <div class="yuan dis-cent">
                  <div class="iconfont icon-close"></div>
                </div>
                <div class="txt">急聘岗位时间</div>
              </div>
              <div class="textBox">
                <div class="yuan dis-cent">
                  <div class="iconfont icon-close"></div>
                </div>
                <div class="txt">在广告位上免费投放广告6个月</div>
              </div>
              <div class="textBox">
                <div class="yuan dis-cent">
                  <div class="iconfont icon-close"></div>
                </div>
                <div class="txt">免费在本网站直接查询人才信息</div>
              </div>
            </div>
          </div>
          <div class="box1">
            <div class="name">金卡会员</div>
            <div class="contBox">
              <div class="textBox">
                <div class="yuan dis-cent">
                  <div class="iconfont icon-right"></div>
                </div>
                <div class="txt">免费发布招聘信息</div>
              </div>
              <div class="textBox">
                <div class="yuan dis-cent">
                  <div class="iconfont icon-right"></div>
                </div>
                <div class="txt">急聘岗位时间</div>
              </div>
              <div class="textBox">
                <div class="yuan dis-cent">
                  <div class="iconfont icon-right"></div>
                </div>
                <div class="txt">在广告位上免费投放广告6个月</div>
              </div>
              <div class="textBox">
                <div class="yuan dis-cent">
                  <div class="iconfont icon-right"></div>
                </div>
                <div class="txt">免费在本网站直接查询人才信息</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="titleBox">
      <div class="line1"></div>
      <div class="name">请选择适合您的企业VIP套餐</div>
      <div class="line2"></div>
    </div>
    <div class="content">
      <div class="cont" v-for="item in vipList">
        <div class="title">
          <div class="name">{{ item.setmeal_name }}</div>
          <div class="typeList">
            <!-- <div
              class="type"
              :class="typeOn == index ? 'on' : ''"
              v-for="(item, index) in typeList"
              @click="typeClick(index)"
            >
              {{ item }}
            </div> -->
          </div>
        </div>
        <div class="contBox">
          <div class="moneyBox">
            <div class="txt">￥</div>
            <div class="num">{{ item.expense }}<span style="font-size: 30px;margin-left: 5px;">/年</span></div>
          </div>
          <div class="gmBtn dis-cent" @click="jump(item.id)">立即购买</div>
          <div class="boxs" v-if="item.setmeal_name == '普通会员'">
            <div class="box">
              <div class="yuan dis-cent">
                <div class="iconfont icon-right"></div>
              </div>
              <div class="text">发布职位数（10个/年）</div>
            </div>
            <div class="box">
              <div class="yuan dis-cent">
                <div class="iconfont icon-right"></div>
              </div>
              <div class="text">手动刷新岗位：4小时可刷新一次</div>
            </div>
            <div class="box">
              <div class="yuan dis-cent">
                <div class="iconfont icon-right"></div>
              </div>
              <div class="text">可下载简历数(200次/年)</div>
            </div>
            <div class="box">
              <div class="yuan dis-cent">
                <div class="iconfont icon-right"></div>
              </div>
              <div class="text">急聘岗位时间：240小时</div>
            </div>
            <div class="box">
              <div class="yuan dis-cent">
                <div class="iconfont icon-right"></div>
              </div>
              <div class="text">线下招聘窗口广告宣传每年1次</div>
            </div>
          </div>
          <div class="boxs" v-if="item.setmeal_name == '银卡会员'">
            <div class="box">
              <div class="yuan dis-cent">
                <div class="iconfont icon-right"></div>
              </div>
              <div class="text">发布职位数（15个/年）</div>
            </div>
            <div class="box">
              <div class="yuan dis-cent">
                <div class="iconfont icon-right"></div>
              </div>
              <div class="text">手动刷新岗位：3小时刷新一次</div>
            </div>
            <div class="box">
              <div class="yuan dis-cent">
                <div class="iconfont icon-right"></div>
              </div>
              <div class="text">可下载简历数(500次/年)</div>
            </div>
            <div class="box">
              <div class="yuan dis-cent">
                <div class="iconfont icon-right"></div>
              </div>
              <div class="text">急聘岗位时间：480小时</div>
            </div>
            <div class="box">
              <div class="yuan dis-cent">
                <div class="iconfont icon-right"></div>
              </div>
              <div class="text">招聘会定制展架1次</div>
            </div>
            <div class="box">
              <div class="yuan dis-cent">
                <div class="iconfont icon-right"></div>
              </div>
              <div class="text">线下招聘窗口广告宣传每年5次</div>
            </div>
            <div class="box">
              <div class="yuan dis-cent">
                <div class="iconfont icon-right"></div>
              </div>
              <div class="text">公众号发布广告每年3次</div>
            </div>
          </div>
          <div class="boxs" v-if="item.setmeal_name == '金卡会员'">
            <div class="box">
              <div class="yuan dis-cent">
                <div class="iconfont icon-right"></div>
              </div>
              <div class="text">发布职位数（35个/年）</div>
            </div>
            <div class="box">
              <div class="yuan dis-cent">
                <div class="iconfont icon-right"></div>
              </div>
              <div class="text">自动刷新岗位：2小时刷新一次</div>
            </div>
            <div class="box">
              <div class="yuan dis-cent">
                <div class="iconfont icon-right"></div>
              </div>
              <div class="text">可下载简历数(900次/年)</div>
            </div>
            <div class="box">
              <div class="yuan dis-cent">
                <div class="iconfont icon-right"></div>
              </div>
              <div class="text">急聘岗位时间：1000小时</div>
            </div>
            <div class="box">
              <div class="yuan dis-cent">
                <div class="iconfont icon-right"></div>
              </div>
              <div class="text">招聘会定制展架3次</div>
            </div>
            <div class="box">
              <div class="yuan dis-cent">
                <div class="iconfont icon-right"></div>
              </div>
              <div class="text">招聘会代招1次</div>
            </div>
            <div class="box">
              <div class="yuan dis-cent">
                <div class="iconfont icon-right"></div>
              </div>
              <div class="text">线下招聘窗口广告宣传每年12次</div>
            </div>
            <div class="box">
              <div class="yuan dis-cent">
                <div class="iconfont icon-right"></div>
              </div>
              <div class="text">公众号发布广告每年8次</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="h-50"></div>
    <div class="titleBox">
      <div class="line1"></div>
      <div class="name">其他服务套餐</div>
      <div class="line2"></div>
    </div>
    <div class="fwCont">
      <div class="cont">
        <!-- <div class="typeList">
          <div class="type dis-cent on">200元(文字)/月</div>
          <div class="type dis-cent">200元(图片)/月</div>
          <div class="type dis-cent">200元(最新招聘)/月</div>
        </div> -->
        <div class="contBox">
          <div class="gmBtn dis-cent" @click="jump(8)">立即购买</div>
          <div class="title">点数制会员100元/次/年</div>
          <div class="text">1、可发布两个职位</div>
          <!-- <div class="text">2、每星期免费刷新一次职位</div> -->
          <div class="text">2、可下载30份简历</div>
        </div>
      </div>
      <div class="cont">
        <!-- <div class="typeList">
          <div class="type dis-cent on">200元(文字)/月</div>
          <div class="type dis-cent">200元(图片)/月</div>
          <div class="type dis-cent">200元(最新招聘)/月</div>
        </div> -->
        <div class="contBox">
          <div class="gmBtn dis-cent" @click="xianxiaClick(1)">立即购买</div>
          <div class="title">线下招聘窗口广告宣传50元/次</div>
          <div class="text">1、可以在线下招聘窗口发布广告</div>
        </div>
      </div>
      <div class="cont">
        <!-- <div class="typeList">
          <div class="type dis-cent on">200元(文字)/月</div>
          <div class="type dis-cent">200元(图片)/月</div>
          <div class="type dis-cent">200元(最新招聘)/月</div>
        </div> -->
        <div class="contBox">
          <div class="gmBtn dis-cent" @click="xianxiaClick(2)">立即购买</div>
          <div class="title">首页招聘广告新闻宣传200元/次</div>
          <div class="text">1、可以在首页新闻招聘处展示您的信息</div>
        </div>
      </div>
      <!-- <div class="cont">
        <div class="typeList">
          <div class="type dis-cent on">30元/(10点+3条招聘信息)</div>
          <div class="type dis-cent">50元/(20点+5条招聘信息)</div>
        </div>
        <div class="contBox">
          <div class="gmBtn dis-cent">立即购买</div>
          <div class="title">点数制会员</div>
          <div class="text">1、每查询一位求职者信息简历和联系方式将扣除1点</div>
          <div class="text">2、每发布一条招聘信息也将扣除一点</div>
        </div>
      </div> -->
    </div>
    <div class="h-50"></div>
    <div class="titleBox">
      <div class="line1"></div>
      <div class="name">对公线下付款</div>
      <div class="line2"></div>
    </div>
    <div class="lxCont">
      <div class="cont">户名：玉环市人力资源配置服务有限公司</div>
      <div class="cont">开户行：中信银行股份有限公司台州玉环支行</div>
      <div class="cont">银行账号：8110 8010 1180 2675 745</div>
      <div class="cont">邮箱：1015615762@qq.com (汇款后请把汇款底单发送至邮箱，我们会即时为你开通会员服务)</div>
    </div>
    <div class="h-50"></div>
    <div class="titleBox">
      <div class="line1"></div>
      <div class="name">联系方式</div>
      <div class="line2"></div>
    </div>
    <div class="lxCont">
      <div class="cont">联系公司：玉环市人力资源配置服务有限公司</div>
      <div class="cont">地址：玉环市玉城街道城中路21号</div>
      <div class="cont">咨询电话：0576-87221221 87232015</div>
      <div class="cont">邮箱：1015615762@qq.com</div>
    </div>
    <XxzpSave v-if="xxShow" :type="ggType"  @show="xxzDelClick" />
  </div>
</template>

<script>
import XxzpSave from "../component/xxzpSave.vue";

export default {
  components: {
    XxzpSave,
  },
  name: "",
  data() {
    return {
      xxShow: false,
      typeOn: 0,
      typeList: ["半年", "一年"],
      xsShow: false,
      vipList: [],
      ggType: 0,
    };
  },
  created() {
    this.getlog();
    this.vipget();
  },
  methods: {
    xianxiaClick(type){
      this.ggType = type
      this.xxShow = true
    },
    xxzDelClick(data) {
      this.xxShow = false;
      if (data) {
        if (data.data.order_id) {
          this.order_id = data.data.order_id;
          this.visible = true;
        }
      }
    },
    vipget() {
      this.$get("/nozzle/web/vip_list").then((res) => {
        console.log(res);
        this.vipList = res.data;
      });
    },
    jump(id) {
      this.$post("/nozzle/web/company_buy_vip", {
        setmeal_id: id,
      }).then((res) => {
        console.log(res);
        if (res.data.status == 1) {
          this.$router.push({
            path: "/pay",
            query: {
              id: res.data.data,
            },
          });
        }else{
        this.$message.error(res.data.msg);
        }
      });
    },
    getlog() {
      this.$get("/nozzle/web/check_login_status").then((res) => {
        if (res.status) {
          this.xsShow = false;
        } else {
          this.xsShow = true;
        }
      });
    },
    typeClick(i) {
      this.typeOn = i;
    },
    syJump() {
      this.$router.push({
        path: "/index",
        query: {},
      });
    },
    logJump() {
      this.$router.push({
        path: "/login",
        query: {},
      });
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.bjb1f {
  background-color: #1a1b1f;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}

.headBj {
  position: relative;
  .headBjBox {
    position: absolute;
    top: 0;
    z-index: 2;
    width: 100%;
    .moyHeadBox {
      width: 1320px;
      height: 80px;
      margin: auto;
      color: #fff;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .logo {
        height: 45px;
        cursor: pointer;
      }
      .box {
        border: 1px solid #fff;
        color: #fff;
        height: 35px;
        width: 80px;
        border-radius: 35px;
        cursor: pointer;
      }
    }
    .moyTitle {
      width: 1280px;
      margin: auto;
      padding-top: 50px;
      height: 220px;
      padding-left: 30px;
      .name {
        background-image: -webkit-linear-gradient(left, #f6b67b, #edc589);
        font-weight: 700;
        font-size: 46px;
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .text {
        color: #fff;
        opacity: 0.7;
        margin-left: 5px;
      }
    }
    .moyCont {
      width: 1150px;
      height: 170px;
      margin: auto;
      margin-top: 25px;
      display: flex;
      .box {
        color: #e6af77;
        width: 50%;
        padding: 35px 30px;
        padding-right: 100px;
        font-weight: 500;
        .name {
          font-size: 22px;
          margin-bottom: 2px;
        }
        .contBox {
          display: flex;
          flex-wrap: wrap;
          .textBox {
            width: 50%;
            margin-top: 15px;
            display: flex;
            align-items: center;
            .yuan {
              width: 16px;
              height: 16px;
              background-color: #e4ad5a;
              color: #1a1b1f;
              border-radius: 50%;
              margin-right: 8px;
              .iconfont {
                position: relative;
                top: 1px;
                font-size: 10px;
                font-weight: 600;
              }
            }
          }
        }
      }
      .box1 {
        color: #9b4207;
        width: 50%;
        padding: 35px 30px;
        padding-left: 100px;
        font-weight: 600;
        .name {
          font-size: 22px;
          margin-bottom: 2px;
        }
        .contBox {
          display: flex;
          flex-wrap: wrap;
          .textBox {
            width: 50%;
            margin-top: 15px;
            display: flex;
            align-items: center;
            .yuan {
              width: 16px;
              height: 16px;
              background-color: #9b4207;
              color: #fff;
              border-radius: 50%;
              margin-right: 8px;
              .iconfont {
                position: relative;
                top: 1px;
                font-size: 10px;
                font-weight: 500;
              }
            }
          }
        }
      }
    }
  }
  .headImg {
    z-index: 2;
    position: relative;
    margin: auto;
    height: 560px;
    text-align: center;
    display: flex;
    justify-content: center;
    overflow: hidden;
    img {
      width: auto;
    }
  }
}

.titleBox {
  display: flex;
  align-items: center;
  margin: auto;
  position: relative;
  justify-content: center;
  z-index: 2;
  margin-top: 30px;
  .line1 {
    height: 2px;
    width: 150px;
    background: linear-gradient(to left, #f8b063, rgba(255, 255, 255, 0));
  }
  .line2 {
    height: 2px;
    width: 150px;
    background: linear-gradient(to right, #f8b063, rgba(255, 255, 255, 0));
  }
  .name {
    font-weight: 600;
    font-size: 30px;
    background-image: -webkit-linear-gradient(left, #f8b063, #fed59f);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin: 0 20px;
  }
}

.content {
  width: 1280px;
  margin: auto;
  position: relative;
  z-index: 2;
  padding-top: 50px;
  display: flex;
  justify-content: space-between;
  .cont {
    background-color: #1b1a19;
    border: 1px solid hsla(32, 91%, 74%, 0.4);
    border-radius: 16px;
    color: #fff;
    width: 375px;
    // height: 100px;
    .title {
      height: 70px;
      padding: 0 30px;
      border-bottom: 1px solid #3d3a39;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .name {
        font-size: 22px;
        background-image: -webkit-linear-gradient(left, #f8b063, #fed59f);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-weight: 600;
      }
      .typeList {
        display: flex;
        align-items: center;
        .type {
          margin-left: 20px;
          color: #969493;
          cursor: pointer;
        }
        .on {
          color: #f8b063;
        }
      }
    }
    .contBox {
      padding: 30px;
      .moneyBox {
        display: flex;
        align-items: flex-end;
        .txt {
          font-size: 24px;
          position: relative;
          top: -13px;
          margin-right: 5px;
        }
        .num {
          font-weight: 600;
          font-size: 58px;
        }
      }
      .gmBtn {
        width: 120px;
        height: 45px;
        border-radius: 10px;
        color: #272525;
        background: linear-gradient(to left, #f8b063, #fed59f);
        margin-top: 10px;
        cursor: pointer;
      }
      .boxs {
        padding-top: 40px;
        .box {
          display: flex;
          align-items: center;
          margin-bottom: 15px;
          .yuan {
            width: 20px;
            height: 20px;
            background-color: #f79d3d;
            color: #fff;
            border-radius: 50%;
            margin-right: 10px;
            .iconfont {
              position: relative;
              font-size: 12px;
              font-weight: 500;
            }
          }
          .text {
            color: #f7d9b2;
          }
        }
      }
    }
  }
}

.fwCont {
  width: 1280px;
  margin: auto;
  position: relative;
  z-index: 2;
  padding-top: 50px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .cont {
    background-color: #1b1a19;
    border: 1px solid hsla(32, 91%, 74%, 0.4);
    border-radius: 16px;
    color: #fff;
    width: calc(50% - 20px);
    margin-right: 40px;
    margin-bottom: 40px;
    .typeList {
      border-bottom: 1px solid #3d3a39;
      height: 70px;
      box-sizing: border-box;
      display: flex;
      .type {
        height: 70px;
        box-sizing: border-box;
        border-bottom: 1px solid #3d3a39;
        flex: 1;
        cursor: pointer;
        color: #d6d6d5;
        font-size: 16px;
      }
      .on {
        border-bottom: 1px solid #f8b063;
        color: #f8b063;
      }
    }
    .contBox {
      padding: 25px 30px 30px;
      position: relative;
      .gmBtn {
        width: 120px;
        height: 45px;
        border-radius: 10px;
        color: #272525;
        background: linear-gradient(to left, #f8b063, #fed59f);
        margin-top: 10px;
        position: absolute;
        bottom: 30px;
        right: 30px;
        cursor: pointer;
      }
      .title {
        font-size: 24px;
        margin-bottom: 15px;
        font-weight: 600;
        background-image: -webkit-linear-gradient(left, #f8b063, #fed59f);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .text {
        margin-bottom: 10px;
      }
      .text:last-child {
        margin-bottom: 0;
      }
    }
  }
  .cont:nth-child(2n) {
    margin-right: 0;
  }
}
.lxCont {
  width: 1280px;
  margin: auto;
  position: relative;
  z-index: 2;
  padding-top: 50px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .cont {
    background-color: #1b1a19;
    border: 1px solid hsla(32, 91%, 74%, 0.4);
    margin-right: 40px;
    padding: 30px;
    border-radius: 16px;
    color: #f8b063;
    width: calc(50% - 20px);
    margin-right: 40px;
    margin-bottom: 40px;
    font-size: 16px;
  }
  .cont:nth-child(2n) {
    margin-right: 0;
  }
}
</style>
